import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
    collection,
    doc,
    getDoc,
    limit,
    onSnapshot,
    orderBy,
    query,
    where
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';

function Roomcleaned() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [cleanrooms, setcleanrooms] = useState([]);
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [searchText, setsearchText] = useState("");

    // Pagination
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });

    const fethUsers = async () => {
        try {
            if (userData && loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    setusername(docSnap.data().username);
                    setloadincount(false)
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);

    const fetchData1 = async () => {
        try {
            const q = query(
                collection(db, 'cleaningrooms'),
                orderBy("createdAt", "desc"),
                where('status', '==', 'Cleaned'),
                limit(500)
            )
            onSnapshot(q, (querySnapshot) => {
                setcleanrooms(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
                setPage(1); // reset to first page when data loads
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = cleanrooms.filter((item) => {
                const room = String(item.data.roomname || item.data.roomno || "").toUpperCase();
                return room.includes(searchText.toUpperCase());
            });
            setcleanrooms(filteredData);
            setPage(1);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    // Pagination logic
    const indexOfLast = page * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentRooms = cleanrooms.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(cleanrooms.length / rowsPerPage);

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content">
                    <div className="container-fluid">
                        <button
                            className="btn btn-secondary mb-2"
                            style={{ textTransform: "uppercase" }}
                        >
                            || Cleaned Rooms ||
                        </button>

                        <div className="card card-primary card-outline">
                            <div className="p-2">
                                <input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4'
                                    placeholder='Search by Room No...'
                                />
                            </div>

                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover table-striped table-head-fixed text-center">
                                    <thead className="table-primary">
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Room No</th>
                                            <th>Cleaned By</th>
                                            <th>Cleaned Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRooms.length > 0 ? (
                                            currentRooms.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td width="80">{indexOfFirst + index + 1}</td>
                                                    <td>{item.data.roomname || item.data.roomno}</td>
                                                    <td>{item.data.cleanedby}</td>
                                                    <td>{item.data.cleanedtime}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-muted">
                                                    No records found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {cleanrooms.length > rowsPerPage && (
                                <div className="d-flex justify-content-between align-items-center p-2">
                                    <span>Page {page} of {totalPages}</span>
                                    <div>
                                        <button
                                            className="btn btn-outline-secondary btn-sm me-2"
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            ◀ Prev
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            disabled={page === totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            Next ▶
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Roomcleaned
